import { render, staticRenderFns } from "./WindowFilePreview.vue?vue&type=template&id=53227753"
import script from "./WindowFilePreview.vue?vue&type=script&lang=js"
export * from "./WindowFilePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports